import type { ApiResponseEnvelope, RequestContext } from '../fetch/apiClient';

export function requestError(
  respBody: ApiResponseEnvelope<unknown>,
  _respHeaders: Record<string, string>,
  _request: RequestContext,
): void {
  if (respBody.error && import.meta.env.MODE === 'development') {
    console.error('Request failed:', respBody.error);
  }
}
